var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSalesBadge = function SvgSalesBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 92,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 238.623,
    height: 92,
    x: 0.705,
    fill: "#fff",
    fillOpacity: 0.43,
    rx: 15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40.032,
    height: 40.032,
    x: 21.705,
    y: 25.984,
    stroke: "url(#sales-badge_svg__a)",
    strokeWidth: 2,
    rx: 20.016
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sales-badge_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#sales-badge_svg__c)",
    d: "M43.446 49.333h.759c5.535 0 7.5-2.916 7.5-5.416a2.92 2.92 0 0 0-2.367-2.861q.2-.405.34-.834a3.24 3.24 0 0 0-.52-2.881A3.32 3.32 0 0 0 46.477 36H36.93a3.32 3.32 0 0 0-2.678 1.343 3.24 3.24 0 0 0-.522 2.882q.141.43.341.833a2.916 2.916 0 0 0-2.366 2.859c0 2.5 1.964 5.416 7.5 5.416h.758q.073.38.075.768v2.566a1.57 1.57 0 0 1-1.667 1.666h-1.666a.834.834 0 0 0 0 1.667h10a.833.833 0 1 0 0-1.667h-1.662a1.572 1.572 0 0 1-1.672-1.666V50.1a4 4 0 0 1 .075-.767m1.364-2.375a19.6 19.6 0 0 0 3.666-4.355q.15.062.312.064a1.25 1.25 0 0 1 1.25 1.25c0 1.813-1.533 3.75-5.833 3.75h-.047q.283-.394.652-.71m-5.605.709c-4.301 0-5.834-1.937-5.834-3.75a1.25 1.25 0 0 1 1.25-1.25.8.8 0 0 0 .313-.064 19.6 19.6 0 0 0 3.666 4.355q.369.315.651.709z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1AA",
    d: "M127.765 30.962c-1.812 0-3.06-1.476-3.06-3.528 0-2.16 1.368-3.528 3.06-3.528 1.02 0 1.824.504 2.268 1.32h.024v-4.068h1.224v7.524c0 1.104.084 1.56.216 2.076h-1.212a4.4 4.4 0 0 1-.156-1.104h-.024c-.504.888-1.404 1.308-2.34 1.308m-1.788-3.528c0 1.368.852 2.376 2.028 2.376 1.164 0 2.076-.984 2.076-2.388s-.912-2.376-2.076-2.376c-1.176 0-2.028 1.008-2.028 2.388M122.043 30.758v-9.6h1.224v9.6zM117.249 30.962c-2.004 0-3.396-1.44-3.396-3.516s1.392-3.54 3.396-3.54c1.98 0 3.372 1.464 3.372 3.54s-1.392 3.516-3.372 3.516m-2.112-3.516c0 1.392.852 2.376 2.112 2.376 1.236 0 2.088-.984 2.088-2.376 0-1.404-.852-2.388-2.088-2.388-1.26 0-2.112.984-2.112 2.388M110.47 30.962c-1.416 0-2.484-.744-2.82-1.872l1.128-.36c.324.792 1.02 1.224 1.68 1.224.48 0 1.212-.228 1.212-.948 0-.624-.6-.816-1.188-.984l-.672-.192c-.72-.216-1.848-.66-1.848-1.956 0-1.272 1.116-1.968 2.34-1.968 1.236 0 2.16.72 2.448 1.656l-1.14.384c-.192-.54-.636-1.032-1.368-1.032-.612 0-1.056.336-1.056.876 0 .672.78.924 1.368 1.092l.564.168c.684.192 1.836.528 1.836 1.824 0 1.224-.996 2.088-2.484 2.088M101.388 30.962c-1.416 0-2.484-.744-2.82-1.872l1.128-.36c.324.792 1.02 1.224 1.68 1.224.48 0 1.212-.228 1.212-.948 0-.624-.6-.816-1.188-.984l-.672-.192c-.72-.216-1.848-.66-1.848-1.956 0-1.272 1.116-1.968 2.34-1.968 1.236 0 2.16.72 2.448 1.656l-1.14.384c-.192-.54-.636-1.032-1.368-1.032-.612 0-1.056.336-1.056.876 0 .672.78.924 1.368 1.092l.564.168c.684.192 1.836.528 1.836 1.824 0 1.224-.996 2.088-2.484 2.088M96.682 30.962c-1.908 0-1.908-1.524-1.908-2.256v-3.504h-1.32v-1.104h1.32v-1.932h1.212v1.932h1.932v1.104h-1.932v3.096c0 .696 0 1.56.936 1.56.3 0 .648-.096.996-.3v1.116c-.336.192-.792.288-1.236.288M91.141 30.758v-6.66h1.224v6.66zm-.228-8.892c0-.444.36-.828.852-.828a.83.83 0 0 1 .828.828c0 .492-.36.864-.828.864-.492 0-.852-.372-.852-.864M83.512 30.758v-6.66h1.2v1.14h.024c.504-.924 1.32-1.332 2.22-1.332 1.2 0 2.376.744 2.376 2.664v4.188h-1.224V27.11c0-1.296-.552-2.052-1.548-2.052-1.104 0-1.824.9-1.824 2.124v3.576zM78.18 30.962c-2.591 0-3.443-1.728-3.443-3.732v-5.832h1.296v5.736c0 1.704.708 2.628 2.172 2.628 1.452 0 2.16-.924 2.16-2.628v-5.736h1.296v5.832c0 1.812-.732 3.732-3.48 3.732"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sales-badge_svg__d)",
    d: "m152.041 24.498-3.046-3.038a1.414 1.414 0 0 0-1.997 0l-3.046 3.038a.708.708 0 1 0 1.006 1l2.33-2.331v7.791a.708.708 0 0 0 1.417 0v-7.791l2.33 2.33a.71.71 0 0 0 1.003.004.71.71 0 0 0 .003-1.003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sales-badge_svg__e)",
    d: "M170.145 26.222c-1.056 0-1.728-.936-1.728-2.28s.672-2.292 1.728-2.292 1.728.948 1.728 2.292-.672 2.28-1.728 2.28m-1.452 4.428 6.672-8.604h1.092l-6.624 8.604zm.756-6.708c0 .936.288 1.38.696 1.38s.684-.432.684-1.38-.276-1.38-.684-1.38-.696.444-.696 1.38m4.068 4.596c0-1.356.672-2.304 1.728-2.304s1.728.96 1.728 2.304c0 1.332-.672 2.28-1.728 2.28s-1.728-.936-1.728-2.28m1.032 0c0 .936.276 1.368.696 1.368.408 0 .684-.432.684-1.368 0-.948-.276-1.392-.684-1.392-.42 0-.696.444-.696 1.392"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sales-badge_svg__f)",
    d: "M162.706 30.65c0-2.412 1.308-6.264 3.588-8.352h-5.112v-1.116h6.6v1.152c-2.448 2.196-3.72 5.892-3.72 8.316z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sales-badge_svg__g)",
    d: "M158.513 30.65v-7.068c-.444.576-1.212 1.008-2.016 1.152v-1.308c1.188-.276 2.052-1.152 2.052-2.136h1.26v9.36z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2F36",
    d: "M207.246 57.916v8.89h-3.018V50.374h3.018v4.83l-.022.014a8.4 8.4 0 0 1 .842-2.213q.56-.984 1.342-1.662a5.7 5.7 0 0 1 1.781-1.051 6.2 6.2 0 0 1 2.154-.365q1.409 0 2.519.529 1.11.53 1.878 1.528.768.99 1.178 2.422.41 1.425.41 3.212v9.19h-3.019v-9.19q0-1.237-.261-2.161-.26-.932-.79-1.55a3.3 3.3 0 0 0-1.319-.94q-.79-.312-1.848-.312-.76 0-1.416.164-.649.156-1.193.462a3.9 3.9 0 0 0-.954.76 4.1 4.1 0 0 0-.7 1.036q-.283.581-.433 1.297a7.5 7.5 0 0 0-.149 1.543M186.154 58.586q0-1.297.261-2.444a9 9 0 0 1 .753-2.11 7.7 7.7 0 0 1 1.192-1.721 7 7 0 0 1 1.603-1.297 7.6 7.6 0 0 1 1.952-.805 8.8 8.8 0 0 1 2.274-.283q1.207 0 2.265.283a7.5 7.5 0 0 1 1.96.805 6.9 6.9 0 0 1 1.595 1.297q.708.76 1.2 1.721t.753 2.11.261 2.444-.261 2.445a9 9 0 0 1-.753 2.117 7.6 7.6 0 0 1-1.2 1.721 7.3 7.3 0 0 1-1.602 1.297 7.4 7.4 0 0 1-1.953.805 8.7 8.7 0 0 1-2.265.283 8.8 8.8 0 0 1-2.274-.283 7.6 7.6 0 0 1-1.952-.805 7.4 7.4 0 0 1-1.595-1.297 7.6 7.6 0 0 1-1.2-1.721 9 9 0 0 1-.753-2.117 11 11 0 0 1-.261-2.445m3.019 0q0 1.38.342 2.482.351 1.096.999 1.863a4.46 4.46 0 0 0 1.588 1.185q.931.41 2.094.41t2.087-.41a4.3 4.3 0 0 0 1.58-1.177q.649-.775.991-1.87.35-1.104.35-2.483t-.35-2.474q-.343-1.105-.991-1.87a4.3 4.3 0 0 0-1.58-1.178q-.924-.41-2.087-.41t-2.094.41a4.4 4.4 0 0 0-1.588 1.177q-.648.768-.999 1.87-.342 1.096-.342 2.475M184.13 50.373v16.434h-3.018V50.373zm.075-5.627v3.726h-3.168v-3.726zM178.715 44.746v22.061h-3.018V44.746zM173.3 44.746v22.061h-3.019V44.746zM167.885 50.373v16.434h-3.019V50.373zm.074-5.627v3.726h-3.167v-3.726zM157.122 45.491h5.299v21.316h-3.131V47.034h.418l-7.55 19.773h-4.397l-7.454-19.773h.41v19.773h-3.055V45.491h5.314l7.46 19.915h-.879zM123.014 63.02h-3.13V49.04h3.13zm5.426-5.611h-13.982V54.65h13.982zM111.858 66.807H95.156v-2.78q0-1.252.32-2.206a5.8 5.8 0 0 1 .872-1.684 6 6 0 0 1 1.275-1.245 10 10 0 0 1 1.543-.902q.82-.388 1.669-.663a80 80 0 0 1 1.662-.53l.999-.298q.753-.231 1.431-.447.686-.215 1.274-.47a7.4 7.4 0 0 0 1.066-.558q.484-.306.82-.708.342-.41.522-.932.186-.522.186-1.2 0-.872-.365-1.64a4 4 0 0 0-1.036-1.341 4.9 4.9 0 0 0-1.618-.91q-.946-.335-2.116-.335-1.2 0-2.176.365a4.8 4.8 0 0 0-1.67 1.014q-.686.656-1.058 1.58a5.3 5.3 0 0 0-.373 2.027v.395h-3.13v-.454q0-1.804.589-3.25a6.8 6.8 0 0 1 1.706-2.467q1.118-1.02 2.706-1.572t3.577-.552q1.93 0 3.436.514 1.506.515 2.542 1.446a6.1 6.1 0 0 1 1.572 2.244q.544 1.305.544 2.899 0 1.23-.313 2.161a5.5 5.5 0 0 1-.835 1.632q-.521.694-1.222 1.193a9 9 0 0 1-1.476.85 13 13 0 0 1-1.587.61q-.812.255-1.565.463l-1.319.38q-.612.171-1.252.365-.635.194-1.23.447a8 8 0 0 0-1.126.59 4.3 4.3 0 0 0-.916.79 3.4 3.4 0 0 0-.612 1.042q-.223.59-.223 1.357v.462l-.999-.589h14.608zM92.61 62.782v4.025h-3.8v-4.025zM82.518 45.037v19.176l-.09-.313h3.861v2.907H75.616V63.9h3.861l-.09.313V51.35l.09.09h-4.74v-2.683h1.915a6 6 0 0 0 1.021-.075q.448-.074.783-.246t.566-.454q.24-.284.38-.694.15-.416.217-.968.066-.56.067-1.282z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sales-badge_svg__a",
    x1: 31.213,
    x2: 59.234,
    y1: 24.984,
    y2: 67.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sales-badge_svg__c",
    x1: 36.705,
    x2: 50.038,
    y1: 36,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sales-badge_svg__d",
    x1: 145.871,
    x2: 153.414,
    y1: 21.048,
    y2: 30.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sales-badge_svg__e",
    x1: 170.556,
    x2: 176.819,
    y1: 21.65,
    y2: 30.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sales-badge_svg__f",
    x1: 162.832,
    x2: 169.663,
    y1: 21.182,
    y2: 28.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sales-badge_svg__g",
    x1: 157.325,
    x2: 162.923,
    y1: 21.29,
    y2: 24.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sales-badge_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.705 36h20v20h-20z"
  })))));
};
export default SvgSalesBadge;